import { ExportPayloadSection } from '../../types';
import normalizeXmlName from './normalizeXmlName';

const resolveXmlElementNames = (
  columns: ExportPayloadSection['columns']
): string[] => {
  const used = new Set<string>();

  // Normalization is many-to-one, so distinct columns can still land on one element name.
  return columns.map((column) => {
    const base = normalizeXmlName(column.name);
    let candidate = base;
    let suffix = 2;

    while (used.has(candidate)) {
      candidate = `${base}_${suffix}`;
      suffix += 1;
    }

    used.add(candidate);

    return candidate;
  });
};

export default resolveXmlElementNames;
